// Workspace switcher (server docs: tenancy.md). Company + Space are REAL:
// the selects hold LIDS (opaque handles), the space list follows the
// selected company (g.user.companies), and Apply NAVIGATES to the current
// page under the new tenant prefix — per tab, no server state; the server
// re-resolves and re-gates everything on the way back in. The project
// search/results/favorites and the Project select are the PROJECT-owned
// dimension — showcase until a project wires them (override the partial +
// this file for a custom switcher).

// Repopulate the space select with the chosen company's spaces (default
// space preselected).
function fillSpaces(spaceSel, companyLid) {
	const entry = (window.g?.user?.companies || []).find((c) => c.lid === companyLid);
	spaceSel.innerHTML = '';
	(entry?.spaces || []).forEach((s) => {
		const opt = document.createElement('option');
		opt.value = s.lid;
		opt.textContent = s.name;
		opt.selected = Boolean(s.isDefault);
		spaceSel.appendChild(opt);
	});
}

// The SELECTED company's logo next to the Company select (a native select
// cannot render images inside its options): g.user.companies carries the
// display path; without one the box hides.
function fillLogo(companyLid) {
	const box = document.getElementById('wsCompanyLogo');
	if (!box) return;
	const entry = (window.g?.user?.companies || []).find((c) => c.lid === companyLid);
	const filesUrl = window.g?.settings?.filesUrl || '';
	const img = box.querySelector('img');
	if (entry?.logo && filesUrl && img) {
		img.src = `${filesUrl}/${entry.logo}`;
		box.hidden = false;
	} else {
		if (img) img.removeAttribute('src');
		box.hidden = true;
	}
}

// Favorites dropdown (topbar): showcase — highlight the pick, nothing else
// (the sidebar labels are the REAL tenant now).
function initFavorites() {
	document.querySelectorAll('.favorite-item').forEach((item) => {
		item.addEventListener('click', () => {
			document.querySelectorAll('.favorite-item').forEach((i) => {
				i.classList.toggle('active', i === item);
			});
		});
	});
}

// Centered workspace modal: real company/space selects + the showcase
// project panel.
function initModal() {
	const modalEl = document.getElementById('workspaceModal');
	if (!modalEl || !window.bootstrap) return;

	const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
	const search = document.getElementById('workspaceSearchInput');
	const results = document.getElementById('workspaceResults');
	const company = document.getElementById('wsCompany');
	const space = document.getElementById('wsSpace'); // absent in mode 'company'
	const project = document.getElementById('wsProject'); // absent without showcase data

	if (company) {
		company.addEventListener('change', () => {
			if (space) fillSpaces(space, company.value);
			fillLogo(company.value);
		});
		fillLogo(company.value); // initial state (the ACTIVE company)
	}

	// Apply: navigate to THIS page under the selected tenant — the URL is
	// the state (tenancy.md); g.route.url swaps the context prefix.
	const apply = document.getElementById('wsApply');
	if (apply) {
		apply.addEventListener('click', () => {
			if (!company || !window.g?.route) {
				modal.hide();
				return;
			}
			const current = window.g.route.current();
			const context = { company: company.value };
			if (space) context.space = space.value;
			let target;
			try {
				target = window.g.route.url(current.pattern || '/', { ...(current.params || {}) }, { context });
			} catch {
				target = window.g.route.url('/', {}, { context }); // param-less fallback
			}
			window.location.assign(target);
		});
	}

	// The showcase project panel: picking a result fills the Project select
	// only (companies/spaces are real and stay untouched).
	document.querySelectorAll('.ws-result, .ws-fav').forEach((el) => {
		el.addEventListener('click', () => {
			if (project) project.value = el.getAttribute('data-project');
		});
	});

	// Live search filter over the showcase results
	const filter = () => {
		if (!search || !results) return;
		const q = (search.value || '').trim().toLowerCase();
		let any = false;
		results.querySelectorAll('.ws-result').forEach((item) => {
			const hay = `${item.getAttribute('data-project')} ${item.getAttribute('data-space')} ${item.getAttribute('data-company')}`.toLowerCase();
			const show = hay.includes(q);
			item.hidden = !show;
			if (show) any = true;
		});
		const empty = results.querySelector('.ws-modal-empty');
		if (empty) empty.hidden = any;
	};

	if (search) {
		search.addEventListener('input', filter);
		// Enter picks the first visible result
		search.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				const first = results.querySelector('.ws-result:not([hidden])');
				if (first) {
					e.preventDefault();
					first.click();
				}
			}
		});
	}

	// Clear the search BEFORE the modal renders (so typing right away isn't
	// wiped by a late handler), then focus once it's visible.
	modalEl.addEventListener('show.bs.modal', () => {
		if (search) {
			search.value = '';
			filter();
		}
	});
	modalEl.addEventListener('shown.bs.modal', () => {
		if (search) search.focus();
	});
}

export function initWorkspace() {
	initFavorites();
	initModal();
}
